import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { getHotVideos, getLatestVideos } from "@/mocks/videos";
import { getLatestArticles } from "@/mocks/articles";
import ScrollToTop from "@/components/feature/ScrollToTop";

export default function HomeContent() {
  const hotVideos = getHotVideos(8);
  const latestVideos = getLatestVideos(8);
  const latestArticles = getLatestArticles(3);

  const heroJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "宅男视频",
    url: "https://zhainanvideo.com",
    description: "宅男视频提供91视频、97视频等数字品牌在线入口，免费高清播放，覆盖51视频网站及数字视频平台海量资源，播放流畅不缓冲。",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://zhainanvideo.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(heroJsonLd) }}
      />

      {/* Hero Section */}
      <section className="relative w-full h-[550px] md:h-[650px] flex items-center justify-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20dark%20background%20with%20warm%20orange%20and%20deep%20red%20gradient%20waves%2C%20cinematic%20atmospheric%20lighting%20with%20soft%20glow%20effects%2C%20modern%20streaming%20platform%20vibe%2C%20clean%20minimal%20digital%20art%20style%2C%20no%20text%20no%20people%2C%20professional%20dark%20theme&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt="宅男视频 - 数字视频平台背景"
          className="absolute inset-0 w-full h-full object-cover object-top"
          title="宅男视频 - 91视频97视频在线观看与免费高清"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
        <div className="relative z-10 w-full px-4 md:px-6 text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
            宅男视频
          </h1>
          <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-6 leading-relaxed">
            提供91视频、97视频等数字品牌在线入口，免费高清播放<br className="hidden sm:block" />
            覆盖51视频网站及数字视频平台海量资源，播放流畅不缓冲
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/hot"
              className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-fire-line mr-2"></i>
              热门推荐
            </Link>
            <Link
              to="/category/latest"
              className="px-8 py-3 bg-white/10 hover:bg-white/20 text-white border border-white/20 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-rocket-line mr-2"></i>
              最新上线
            </Link>
          </div>
          <div className="flex items-center justify-center gap-6 mt-8 text-white/60 text-sm flex-wrap">
            <span className="flex items-center gap-1.5">
              <i className="ri-play-circle-line"></i>
              91视频
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-film-line"></i>
              97视频
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-tv-line"></i>
              51视频网站
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-4k-line"></i>
              免费高清
            </span>
          </div>
        </div>
      </section>

      {/* Stats Bar */}
      <section className="bg-background-100 border-b border-background-200/70">
        <div className="w-full px-4 md:px-6 py-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
            {[
              { value: "1000万+", label: "月活跃用户" },
              { value: "50万+", label: "视频资源库" },
              { value: "99.9%", label: "播放流畅率" },
              { value: "4K", label: "超清画质支持" },
            ].map((stat, i) => (
              <div key={i} className="py-3">
                <div className="text-2xl md:text-3xl font-bold text-primary-500">{stat.value}</div>
                <div className="text-xs md:text-sm text-foreground-600 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Category Navigation */}
      <section className="bg-background-50 py-10 md:py-14">
        <div className="w-full px-4 md:px-6">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">视频分类</h2>
            <p className="text-foreground-600 mt-2 text-sm">精选分类入口，快速找到想看的内容</p>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-3">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-2 px-5 py-3 bg-background-100 hover:bg-background-200 border border-background-200/70 rounded-xl text-sm font-medium text-foreground-800 hover:text-foreground-950 transition-all whitespace-nowrap cursor-pointer"
              >
                <div className="w-8 h-8 flex items-center justify-center bg-primary-100 rounded-lg">
                  <i className={`${cat.icon} text-primary-600 text-sm`}></i>
                </div>
                {cat.name}
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Hot Videos */}
      <section className="bg-background-50 py-10 md:py-14">
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">热门推荐</h2>
              <p className="text-foreground-600 mt-1 text-sm">精选热门视频，每日更新</p>
            </div>
            <Link
              to="/category/hot"
              className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer"
            >
              查看全部 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
            {hotVideos.map((video) => (
              <Link
                key={video.id}
                to={`/category/${video.category}`}
                className="group cursor-pointer"
              >
                <div className="relative aspect-video rounded-xl overflow-hidden bg-background-200 mb-3">
                  <img
                    src={video.thumbnail}
                    alt={video.title}
                    title={video.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                    loading="lazy"
                  />
                  <div className="absolute bottom-2 right-2 bg-black/80 text-white text-xs px-1.5 py-0.5 rounded">
                    {video.duration}
                  </div>
                  {video.isHD && (
                    <div className="absolute top-2 left-2 bg-primary-500 text-white text-[10px] px-1.5 py-0.5 rounded font-semibold">
                      HD
                    </div>
                  )}
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all flex items-center justify-center">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 opacity-0 group-hover:opacity-100 transition-all">
                      <i className="ri-play-fill text-foreground-950 text-xl"></i>
                    </div>
                  </div>
                </div>
                <h3 className="text-sm font-medium text-foreground-950 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {video.title}
                </h3>
                <div className="flex items-center gap-3 mt-1.5 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {(video.views / 10000).toFixed(1)}万
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-amber-500"></i>
                    {video.rating}
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Latest Videos */}
      <section className="bg-background-100 py-10 md:py-14">
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">最新上线</h2>
              <p className="text-foreground-600 mt-1 text-sm">第一时间上新，不错过精彩内容</p>
            </div>
            <Link
              to="/category/latest"
              className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer"
            >
              查看全部 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
            {latestVideos.map((video) => (
              <Link
                key={video.id}
                to={`/category/${video.category}`}
                className="group cursor-pointer"
              >
                <div className="relative aspect-video rounded-xl overflow-hidden bg-background-200 mb-3">
                  <img
                    src={video.thumbnail}
                    alt={video.title}
                    title={video.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                    loading="lazy"
                  />
                  <div className="absolute bottom-2 right-2 bg-black/80 text-white text-xs px-1.5 py-0.5 rounded">
                    {video.duration}
                  </div>
                  {video.isHD && (
                    <div className="absolute top-2 left-2 bg-primary-500 text-white text-[10px] px-1.5 py-0.5 rounded font-semibold">
                      HD
                    </div>
                  )}
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all flex items-center justify-center">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 opacity-0 group-hover:opacity-100 transition-all">
                      <i className="ri-play-fill text-foreground-950 text-xl"></i>
                    </div>
                  </div>
                </div>
                <h3 className="text-sm font-medium text-foreground-950 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {video.title}
                </h3>
                <div className="flex items-center gap-3 mt-1.5 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {(video.views / 10000).toFixed(1)}万
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-amber-500"></i>
                    {video.rating}
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Brand Features */}
      <section className="bg-background-50 py-10 md:py-14">
        <div className="w-full px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">为什么选择宅男视频</h2>
            <p className="text-foreground-600 mt-2 text-sm">四大核心优势，打造极致观影体验</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {[
              {
                icon: "ri-speed-line",
                title: "播放不卡顿",
                desc: "先进的CDN分发技术，智能码率自适应，确保流畅播放体验，告别缓冲等待。",
              },
              {
                icon: "ri-4k-line",
                title: "免费高清",
                desc: "支持4K超清画质，无需付费即可享受极致视觉体验，高清专区品质保证。",
              },
              {
                icon: "ri-stack-line",
                title: "海量资源",
                desc: "覆盖91视频、97视频、51视频网站等品牌资源，内容库持续更新扩充。",
              },
              {
                icon: "ri-device-line",
                title: "多端适配",
                desc: "全面支持PC、平板、手机等设备，跨平台无缝切换，随时随地畅享视频。",
              },
            ].map((feature, i) => (
              <div key={i} className="p-6 bg-background-100 rounded-xl border border-background-200/70 text-center">
                <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-xl mx-auto mb-4">
                  <i className={`${feature.icon} text-primary-600 text-xl`}></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2">{feature.title}</h3>
                <p className="text-foreground-600 text-sm leading-relaxed">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Latest Articles */}
      <section className="bg-background-100 py-10 md:py-14">
        <div className="w-full px-4 md:px-6">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">最新资讯</h2>
            <p className="text-foreground-600 mt-2 text-sm">技术分享、使用指南、行业动态</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {latestArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all cursor-pointer"
              >
                <div className="aspect-[2/1] overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                    loading="lazy"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2 flex-wrap">
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {article.readTime}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.views}阅读
                    </span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-foreground-600 text-xs leading-relaxed line-clamp-2">
                    {article.excerpt}
                  </p>
                  <div className="flex flex-wrap gap-1.5 mt-3">
                    {article.tags.slice(0, 2).map((tag, idx) => (
                      <span
                        key={idx}
                        className="px-2 py-0.5 bg-background-100 text-foreground-600 text-[10px] rounded-full"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative py-16 md:py-20 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20dark%20background%20with%20flowing%20orange%20and%20red%20light%20streaks%2C%20cinematic%20dramatic%20lighting%2C%20modern%20digital%20art%20style%2C%20clean%20minimal%20composition%2C%20no%20text%20no%20people&width=1920&height=600&seq=cta-bg&orientation=landscape"
          alt=""
          className="absolute inset-0 w-full h-full object-cover object-top"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-black/70"></div>
        <div className="relative z-10 w-full px-4 md:px-6 text-center">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-4">立即开启流畅观影体验</h2>
          <p className="text-white/70 text-sm md:text-base mb-8 max-w-xl mx-auto">
            无需注册，免费观看海量高清视频。91视频、97视频、51视频网站等数字视频平台资源一网打尽
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/hot"
              className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer"
            >
              热门推荐
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-white/10 hover:bg-white/20 text-white border border-white/20 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}